import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum GoldenDomeNotificationType {
  SLACK = "SLACK",
}

// Maps to the analyst roles on `HubspotTeamInfo.productAnalysts`. When a
// subscription fires, only analysts whose role appears here are tagged in
// the Slack alert.
export enum GoldenDomeProductArea {
  RETURNS = "returns",
  OMS = "oms",
  MARKETING = "marketing",
  CONVERSION = "conversion",
  SHOPPER_AI = "shopperAI",
}

const notificationSentSchema_ = z.object({
  timestamp: z.date().meta({ privacy: privacy.timestamp }),
  teamId: z.string().meta({ privacy: privacy.id.internal }),
  appId: z.string().meta({ privacy: privacy.id.internal }),
});

const goldenDomeNotificationSchema_ = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.id.internal }),
  userEmail: z.string().meta({ privacy: privacy.email.redoInternal }),
  appIds: z
    .array(z.string().meta({ privacy: privacy.id.internal }))
    .meta({ privacy: privacy.id.internal }),
  notificationsSent: z
    .array(notificationSentSchema_)
    .meta({ privacy: privacy.structured }),
  title: z.string().meta({ privacy: privacy.text.redoInternal }),
  customMessage: z
    .string()
    .optional()
    .meta({ privacy: privacy.text.redoInternal }),
  notificationType: createEnum(GoldenDomeNotificationType, {
    enumName: "golden_dome_notification_type",
  }).meta({ privacy: privacy.enumOrStatus }),
  includeAppInstallationRemoved: z
    .boolean()
    .optional()
    .meta({ privacy: privacy.flag }),
  productAreas: z
    .array(
      createEnum(GoldenDomeProductArea, {
        enumName: "golden_dome_product_area",
      }),
    )
    .optional()
    .meta({ privacy: privacy.enumOrStatus }),
  createdAt: z.date().meta({ privacy: privacy.timestamp }),
  updatedAt: z.date().meta({ privacy: privacy.timestamp }),
});

export const GoldenDomeNotificationSchema: z.ZodType<GoldenDomeNotification> =
  goldenDomeNotificationSchema_;
export interface GoldenDomeNotification extends z.infer<
  typeof goldenDomeNotificationSchema_
> {}
